import { SuspendedRoutes } from './type'

const root = `${SuspendedRoutes.root}`

export const SuspendedPath = {
  root: root,
}
